import React from 'react'

const Upcoming = () => (
    <h1>404 Page Not Found</h1>
)

export default Upcoming